import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { Category } from '../types/category.type';
import { ADMIN_CATEGORIES_API_PATHS } from '../constants/categories-api-paths.constants';

type CreateCategoryData = {
  name: string;
  description: string;
  isActive: boolean;
};

type UseCreateCategoryResult = {
  createCategory: (data: CreateCategoryData) => Promise<Category | null>;
  isSubmitting: boolean;
};

export function useCreateCategory(): UseCreateCategoryResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const createCategory = async (data: CreateCategoryData): Promise<Category | null> => {
    setIsSubmitting(true);

    try {
      const category = await HttpClient.post<Category>(ADMIN_CATEGORIES_API_PATHS.CREATE_CATEGORY, data);

      enqueueSnackbar('La rubrique a été créée', { variant: 'success' });
      return category;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, 'Une erreur est survenue lors de la création de la rubrique'),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { createCategory, isSubmitting };
}
